import { environment } from './../../../../environment/environment';
import { Injectable } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { ApiResponse } from './../../../core/models/response-api';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { Consultant } from './../../../core/models/Consultant';

@Injectable({
  providedIn: 'root',
})
export class EsnConsultantService extends CrudService<
  ApiResponse<any>,
  number
> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);
  }

  getskillscandidat(idcandidat: any): Observable<ApiResponse<any>> {
    return this._http
      .get<ApiResponse<any>>(
        `${this._base}/api/Skill/getSkillsByCandidate/${idcandidat}`
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }
/* get elment of header table call odder list */
getHeaderElements(id:number){
  return this._http.get<ApiResponse<any>>(this._base+`/api/UserPageActeur/getPagesWithSubPagesForUser?role_id=7&interface=7&id=${id}`);
}
changeDelectedElementHeader(data: any) {
  return this._http.post<ApiResponse<any>>(
    this._base +
      `/UserPageActeur/addRemoveSubPageToUser?role_id=7&interface=7`,
    data
  );
}
  /* get list offre besoin esn */

  getListconsultant(data: any) {
    let page=1;
    if(data?.page){
      page = data.page +1
    }
    return this._http.get<ApiResponse<any>>(
      `${this._base}/api/ConsultantEsn/getConsultantsByEsn?per_page=${data?.per_page}&page=${page}`
    );
  }
  /*get list consultant   by offre */
  getlistconsultantbyoffre(): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/ConsultantEsn/getConsultantsforConsultantExterne`
    );
  }


  getListintercontrat(data:any) {
    let page = 1 
      if (data?.page) {
        page = data?.page + 1 
      }
    return this._http.get<ApiResponse<any>>(
      `${this._base}/api/ConsultantEsn/getIntercontratByEsn?per_page=${data?.per_page}&page=${page}`);
  }

  searchintercontrat(data: any): Observable<ApiResponse<any>> {
    let tabs = this.findDoubleQuotes(data.search);
    if (tabs.length <= 2) data.search = '"' + data.search + '"';
    return this._http
      .post<ApiResponse<any>>(
        this._base + `/api/ConsultantEsn/searchInListIntercontratOfESN`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }
  // search  consultant //////
  searchconsultant(data: any): Observable<ApiResponse<any>> {
    if(data?.search !== undefined && data?.search !== null) {
      let tabs = this.findDoubleQuotes(data.search);
    if (tabs.length <= 2) data.search = '"' + data.search + '"';
    }

    if(data?.page) {
      data.page = data.page + 1;
    } else{
      data.page = 1;
    }
    return this._http
      .post<ApiResponse<any>>(
        this._base + `/api/ConsultantEsn/searchInListConsultantOfESN`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }
  searchconsultantenvoyer(data: any): Observable<ApiResponse<any>> {
    return this._http
      .post<ApiResponse<any>>(
        this._base + `/api/ConsultantEsn/searchInConsultantForSendEvaluation`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }
  findDoubleQuotes(str: string): number[] {
    const indices: number[] = [];
    for (let i = 0; i < str.length; i++) {
      if (str[i] === '"') {
        indices.push(i);
      }
    }
    return indices;
  }

  /* create consultant */
  createconsultant(body: any): Observable<ApiResponse<Consultant>> {
    return this._http.post<ApiResponse<Consultant>>(
      this._base + '/api/ConsultantEsn/create',
      body
    );
  }
  /*update consultant*/

  updateConsultant(uuid: string, updatedData: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/ConsultantEsn/updateConsultant/${uuid}`,
      updatedData
    );
  }
  /*add Bulk Candidates*/
  addBulkCandidates(data: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/Company/addBulkConsultantESN`,
      data
    );
  }
  /*get bulk candidate */
  getbulkCandidate(data: any) {
    return this._http.get(
      this._base + `/api/Company/exportConsultantEsn/${data}`,
      {
        responseType: 'arraybuffer',
      }
    );
  }
  getconsultantbyemail(email: any): Observable<ApiResponse<any>> {
    const encodedEmail = encodeURIComponent(email);
    const url = `${this._base}/api/User/getUserByMailForAddConsultant?email=${encodedEmail}`;

    return this._http
      .get<ApiResponse<any>>(url)
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }

  getconsultantexternebyemail(email: any): Observable<ApiResponse<any>> {
    return this._http
      .get<ApiResponse<any>>(
        this._base + `/api/User/getUserByMail?email=${email}`
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }

  getclient(): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/ConsultantEsn/getClientForESN`
    );
  }
  // getmanager(id: any): Observable<ApiResponse<any>> {
  //   return this._http.get<ApiResponse<any>>(
  //     this._base + `/api/ConsultantEsn/getManagersForAddConsultant/${id}`
  //   );
  // }
  getmanagernew(): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/CompanyRoles/getUsersByRoleName?role_name=manager`
    );
  }
  /****************fin mission*************** */
  finmission(uuid: string) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/ConsultantEsn/fromConsultantToIntercontrat/${uuid}`,
      {}
    );
  }
  // dissocier consultant esn
  dissocierconsultant(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/ConsultantEsn/disassociateConsultantFromEsn`,
      data
    );
  }

  listPageconsultantActorIntervenant() {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/UserPageActeur/getPagesWithSubPagesForEmployee?interface=7&company_id=2&id=15`
    );
  }
  /* change Sub Page State */
  changeSubPageStateconsultantIntervenant(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/UserPageActeur/addRemoveSubPageByEmployee`,
      data
    );
  }

  downloadcsvfileAddBulkConsultant() {
    const url = `${this._base}/api/Company/uploadEmptyFileAddBulkConsultantESN`;
    return this._http.get(url, {
      responseType: 'blob', // Changer 'arraybuffer' en 'blob'
      // observe: 'response', // Permet d'obtenir la réponse complète incluant les en-têtes
    });
  }
  getAllConsultants(): Observable<any> {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/ConsultantEsn/getListConsultants`);
  }
}
